const orderedTypes = {
  DIRECT: 'Direct',
  BACKORDER: 'Backorder',

};
export const orderedTypesList = [
  { label: orderedTypes.DIRECT, value: orderedTypes.DIRECT },
  { label: orderedTypes.BACKORDER, value: orderedTypes.BACKORDER },
];

export default orderedTypes;
